import { getPowerBtn } from '@/api/power'

let powerBtn = {
  state: {
    btnList: null
  },
  mutations: {
    SET_POWER: (state, btnList) => {
      state.btnList = btnList;
    }
  },
  actions: {
    async GetPowerBtn({commit, state}) {
      await getPowerBtn().then(res => {
        let btnList = {};
        for (let val of res.data) {
          btnList[val.id] = true;
        }
        commit('SET_POWER', btnList);
      })
    }
  }
}
export default powerBtn;



// WEBPACK FOOTER //
// ./src/store/modules/powerBtn.js